import React from 'react';
import { Box, Typography, Paper, SxProps, Theme } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

interface WarningMessageProps {
  message: string;
  show: boolean;
  icon?: React.ComponentType<{ sx?: SxProps<Theme> }>;
  variant?: 'warning' | 'error' | 'info';
}

const WarningMessage: React.FC<WarningMessageProps> = ({
  message,
  show,
  icon: Icon = WarningIcon,
  variant = 'warning',
}) => {
  if (!show) return null;

  const getVariantColors = (variant: string) => {
    switch (variant) {
      case 'error':
        return {
          borderColor: 'error.main',
          color: 'error.main',
        };
      case 'info':
        return {
          borderColor: 'info.main',
          color: 'info.main',
        };
      case 'warning':
      default:
        return {
          borderColor: 'warning.main',
          color: 'warning.main',
        };
    }
  };

  const colors = getVariantColors(variant);

  return (
    <Box
      sx={{
        mt: 1,
        textAlign: 'center',
        backgroundColor: 'transparent',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          color: colors.color,
          backgroundColor: 'transparent',
          '& .MuiPaper-root': { background: 'inherit' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            backgroundColor: 'transparent',
          }}
        >
          <Icon sx={{ fontSize: 20 }} />
          <Typography variant="body2">{message}</Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default WarningMessage;
